export default function() {

    function getFilters() {
        const filters = {};

        jQuery('.wc__archive-filters [data-filter-taxonomy]').each(function() {
            const taxonomy = jQuery(this).data('filter-taxonomy');
            const values = [];
            jQuery(this).find('input[type="checkbox"]:checked').each(function() {
                values.push(jQuery(this).val());
            });
            if (values.length) {
                filters[taxonomy] = values;
            }
        });

        const priceMin = jQuery('#min_price').val();
        const priceMax = jQuery('#max_price').val();
        if (priceMin) filters.min_price = priceMin;
        if (priceMax) filters.max_price = priceMax;

        return filters;
    }

    function getFacets() {
        const facets = [];

        jQuery('.wc__archive-filters [data-filter-taxonomy]').each(function() {
            const taxonomy = jQuery(this).data('filter-taxonomy');
            facets.push(taxonomy);
        });

        return facets;
    }

    function fetchFilteredProducts(page = 1){

        const filters = getFilters();
        const facets = getFacets();

        const currentParams = new URLSearchParams(window.location.search);
        const orderby = currentParams.get('orderby') || '';

        const url = new URL(window.location.href);

        url.pathname = url.pathname.replace(/\/page\/\d+\/?$/, '/');

        for (const key of [...url.searchParams.keys()]) {
            if (key.startsWith('filter_') || key === 'min_price' || key === 'max_price') {
                url.searchParams.delete(key);
            }
        }

        if (orderby) {
            url.searchParams.set('orderby', orderby);
        } else {
            url.searchParams.delete('orderby');
        }

        Object.keys(filters).forEach(key => {
            if (key === 'min_price' || key === 'max_price') {
                url.searchParams.set(key, filters[key]);
            } else if (Array.isArray(filters[key]) && filters[key].length > 0) {
                url.searchParams.set('filter_' + key, filters[key].join(','));
            }
        });

        history.replaceState(null, '', url.toString());

        jQuery('[data-filter="products"]').addClass('wc__archive-grid-loading');

        jQuery.post(ajaxURL, {
            action: 'fetch_filtered_products',
            filters: filters,
            facets: facets,
            orderby: jQuery('select.orderby').val() || '',
            page: page,
            context_taxonomy: jQuery('[data-filter-context]').data('taxonomy') || '',
            context_term: jQuery('[data-filter-context]').data('term') || 0
        }, function(response) {
            if (response.success) {

                jQuery('[data-filter="products"]').removeClass('wc__archive-grid-loading');
                jQuery('[data-filter="products"]').empty();
                jQuery('[data-filter="products"]').html(response.data.products);

                const $pagination = jQuery('[data-filter="pagination"]');
                if (response.data.pagination) {
                    $pagination.replaceWith(response.data.pagination);
                } else {
                    $pagination.replaceWith('<span data-filter="pagination"></span>');
                }

                jQuery('[data-filter="result-count"]').html(response.data.result_count);

                if (response.data.facets) {
                    jQuery('[data-filter-taxonomy]').each(function() {
                        const $filterSet = jQuery(this);
                        const taxonomy = $filterSet.data('filter-taxonomy');
                        const facetCounts = response.data.facets[taxonomy] || {};

                        $filterSet.find('.wc__filter-input').each(function() {
                            const $field = jQuery(this);
                            const $input = $field.find('input[type="checkbox"]');
                            const $label = $field.find('label');
                            const $count = $label.find('.wc__filter-count');
                            const termId = $input.data('term-id');

                            if (facetCounts[termId] > 0) {
                                $count.html(`(${facetCounts[termId]})`);
                                $field.show();
                            } else {
                                // $field.hide();
                            }
                        });
                    });
                }
            }
        });
    }

    jQuery('.wc__archive-filters').on('change', 'input, select', function(e) {
        fetchFilteredProducts();
    });

    jQuery('select.orderby').on('change', function(e){
        e.preventDefault();

        const orderby = jQuery(this).val();
        const url = new URL(window.location.href);
        url.searchParams.set('orderby', orderby);
        history.replaceState({}, '', url);

        fetchFilteredProducts();
    });

    jQuery('form.woocommerce-ordering').on('submit', function(e) {
        e.preventDefault();
    });

    const urlParams = new URLSearchParams(window.location.search);
    let hasActiveFilters = false;

    for (const [key, value] of urlParams) {
        if (key.startsWith('filter_') && value) {
            const taxonomy = key.slice(7);
            value.split(',').forEach(slug => {
                jQuery(`input[name="${taxonomy}[]"][value="${slug}"]`).prop('checked', true);
            });
            hasActiveFilters = true;
        }
        if (key === 'min_price' && value) {
            jQuery('#min_price').val(value);
            hasActiveFilters = true;
        }
        if (key === 'max_price' && value) {
            jQuery('#max_price').val(value);
            hasActiveFilters = true;
        }
    }

    if (hasActiveFilters) {
        renderActiveFilters();
    }

    function getTermName($checkbox) {
        return $checkbox.next('label').text().trim();
    }

    function getTaxonomyLabel(taxonomy) {
        const $wrapper = jQuery(`[data-filter-taxonomy="${taxonomy}"]`).closest('.wc__filter');
        return $wrapper.find('.filter__heading').first().text().trim() || taxonomy;
    }

    function renderActiveFilters() {
        const $container = jQuery('[data-filter="active"]');
        $container.empty();

        const $ul = jQuery('<ul></ul>');

        jQuery('[data-filter-taxonomy]').each(function() {
            const taxonomy = jQuery(this).data('filter-taxonomy');
            const label = getTaxonomyLabel(taxonomy);

            jQuery(`input[name="${taxonomy}[]"]:checked`).each(function() {
                const $checkbox = jQuery(this);
                const termName = getTermName($checkbox);
                const termValue = $checkbox.val();

                const $li = jQuery('<li></li>')
                    .text(`${label}: ${termName}`)
                    .attr('data-taxonomy', taxonomy)
                    .attr('data-value', termValue);

                const $removeBtn = jQuery('<button type="button" aria-label="Remove filter">&times;</button>');
                $li.append($removeBtn);
                $ul.append($li);
            });
        });

        const minPrice = jQuery('#min_price').val();
        const maxPrice = jQuery('#max_price').val();

        if (minPrice) {
            const $li = jQuery('<li></li>').text(`Price min: ${minPrice}`).attr('data-price', 'min');
            const $removeBtn = jQuery('<button type="button" aria-label="Remove price min">&times;</button>');
            $li.append($removeBtn);
            $ul.append($li);
        }

        if (maxPrice) {
            const $li = jQuery('<li></li>').text(`Price max: ${maxPrice}`).attr('data-price', 'max');
            const $removeBtn = jQuery('<button type="button" aria-label="Remove price max">&times;</button>');
            $li.append($removeBtn);
            $ul.append($li);
        }

        if ($ul.children().length > 0) {
            $container.append($ul);
        }
    }

    jQuery('[data-filter="active"]').on('click', 'button', function() {
        const $li = jQuery(this).parent();

        if ($li.data('taxonomy')) {
            const taxonomy = $li.data('taxonomy');
            const value = $li.data('value');
            jQuery(`input[name="${taxonomy}[]"][value="${value}"]`).prop('checked', false);
            jQuery(`input[name="${taxonomy}[]"][value="${value}"]`).trigger('change');
        }

        if ($li.data('price')) {
            if ($li.data('price') === 'min') {
                jQuery('#min_price').val('');
                jQuery('#min_price').trigger('change');
            }
            if ($li.data('price') === 'max') {
                jQuery('#max_price').val('');
                jQuery('#max_price').trigger('change');
            }
        }

        $li.remove();
    });

    jQuery('.wc__archive-filters').on('change', 'input[type="checkbox"], input[type="number"]', function() {
        renderActiveFilters();
    });

    renderActiveFilters();

    jQuery(document).on('click', '[data-filter="pagination"] a', function(e){
        e.preventDefault();
        const href = jQuery(this).attr('href') || '';

        const pathMatch = href.match(/\/page\/(\d+)/);
        const paramMatch = href.match(/[?&]paged=(\d+)/);
        const page = pathMatch ? parseInt(pathMatch[1]) : (paramMatch ? parseInt(paramMatch[1]) : null);

        if (!page) return;

        const basePath = window.location.pathname.replace(/\/page\/\d+\/?$/, '/');
        const targetUrl = new URL(page === 1 ? basePath : basePath + 'page/' + page + '/', window.location.origin);

        for (const [key, value] of new URLSearchParams(window.location.search)) {
            if (key.startsWith('filter_') || key === 'min_price' || key === 'max_price' || key === 'orderby') {
                targetUrl.searchParams.set(key, value);
            }
        }

        window.location.href = targetUrl.toString();
    });

    jQuery(document).ready(function() {
        jQuery('[data-filter="mobile-toggle"]').on('click', function() {
            jQuery('.wc__archive-filters').toggleClass('is-open');
        });
    });

    jQuery(document).on('click', '[data-action="toggle_mobile_filters"]', function(){
        jQuery('.wc__archive-filters').toggleClass('is-open');
        jQuery('.overlay').toggleClass('is-open');
    });

    jQuery(document).on('click', '[data-filter="reset"]', function(e){
        e.preventDefault();
        const $filters = jQuery('.wc__archive-filters');
        if (!$filters.find('input[type="checkbox"]:checked').length && !jQuery('#min_price').val() && !jQuery('#max_price').val()) return;
        $filters.find('input[type="checkbox"]:checked').prop('checked', false);
        jQuery('#min_price, #max_price').val('');
        renderActiveFilters();
        fetchFilteredProducts();
    });


    jQuery('.wc__archive-filters').on('click', '.wc__filter > .u-inner-row', function() {
        const $row = jQuery(this);
        const $filter = $row.closest('.wc__filter');
        const $body = $filter.find('[data-filter-taxonomy]');
        const $svg = $row.find('svg');
        const isOpen = $body.is(':visible');

        // Sluit andere open filters — maximaal 1 tegelijk open
        jQuery('.wc__archive-filters .wc__filter').not($filter).each(function() {
            const $otherBody = jQuery(this).find('[data-filter-taxonomy]');
            if ($otherBody.is(':visible')) {
                $otherBody.stop().animate({ height: '0' }, 300, function() {
                    $otherBody.hide().css('height', '');
                });
                jQuery(this).find('> .u-inner-row svg').removeClass('is-active');
            }
        });

        if (isOpen) {
            $body.stop().animate({ height: '0' }, 300, function() {
                $body.hide().css('height', '');
            });
        } else {
            $body.show();
            const height = $body[0].scrollHeight;
            $body.css('height', '0').stop().animate({ height: height + 'px' }, 300, function() {
                $body.css('height', '');
            });
        }

        $svg.toggleClass('is-active');
    });

    jQuery('.wc__archive-filters [data-filter-taxonomy]').hide();



}